import { render, staticRenderFns } from "./FormHeading.vue?vue&type=template&id=e348231a&scoped=true&"
import script from "./FormHeading.vue?vue&type=script&lang=js&"
export * from "./FormHeading.vue?vue&type=script&lang=js&"
import style0 from "./FormHeading.vue?vue&type=style&index=0&id=e348231a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e348231a",
  null
  
)

export default component.exports